import { useEffect, useState } from 'react';

/** Matches Tailwind's `sm` breakpoint — use to trade off wide, fixed-width
 * table columns for narrower ones so mobile users scroll less horizontally. */
const MOBILE_BREAKPOINT_QUERY = '(max-width: 639px)';

export function useIsMobile(query: string = MOBILE_BREAKPOINT_QUERY): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
